import React, {Component}       from "react";
import {ImageBackground, View}  from "react-native";
import {connect}                from "react-redux";
import * as Font                from "expo-font";
import {Ionicons}               from "@expo/vector-icons";
import ModalHowToPlay           from "../modals/ModalHowToPlay";
import Button                   from "../Button";
import * as Actions             from "../../constants/Actions";
import * as Screens             from "../../constants/Screens";
import styles                   from "../../styles/Styles";

class ScreenTitle extends Component {
    state = {
        ready: false
    }

    async componentDidMount() {
        await Font.loadAsync({
            Roboto:             require("../../../node_modules/native-base/Fonts/Roboto.ttf"),
            Roboto_medium:      require("../../../node_modules/native-base/Fonts/Roboto_medium.ttf"),
            ...Ionicons.font,
        });

        this.setState({ ready: true });
    }

    initSettings = (numPlayers) => {
        this.props.setNumPlayers(numPlayers);
        this.props.changeScreen(Screens.SETTINGS);
    }

    render() {
        return (
            <View style={styles.background}>
                <ImageBackground source={require("../../../assets/screen_title.png")} style={styles.background} imageStyle={styles.backgroundImageStretch}>
                    <ModalHowToPlay />

                    {this.state.ready && 
                        <View style={styles.menu}>
                            <ImageBackground source={require("../../../assets/menu.png")} style={styles.background} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.menuVert}>
                                    <Button onPress={() => {this.initSettings(1)}} text="Admit One" />
                                    <Button onPress={() => {this.initSettings(2)}} text="Group Rate" />
                                    
                                    <View style={styles.menuHorz}>
                                        <Button onPress={() => {this.props.showHowToPlay()}} text="How To Play" />
                                        <Button onPress={() => {this.props.changeScreen(Screens.CREDITS)}} text="Credits" />
                                    </View>
                                </View>
                            </ImageBackground>
                        </View>
                    }
                </ImageBackground>
            </View>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen:   (screen)        => { dispatch({type: Actions.CHANGE_SCREEN,     screen:     screen}) },
        setNumPlayers:  (numPlayers)    => { dispatch({type: Actions.SET_NUM_PLAYERS,   numPlayers: numPlayers, screen: Screens.TITLE}) },
        showHowToPlay:  ()              => { dispatch({type: Actions.SHOW_HOW_TO_PLAY}) },
    };
}

export default connect(null, mapDispatchToProps)(ScreenTitle);